import { HomeV2Actions } from "./homeV2.action";

const initialState = {
    talentInformationForHomePage: {
        avatar: null,
        firstName: null,
        lastName: null,
        roleTypeId: null,
        countryId: null,
        city: null,
        resumeUploadDate: null,
        loading: false,
    },
    countries: [],
    jobRoleTypes: [],
    loading: false,
};

function HomeV2Reducer(state = initialState, action) {
    const { type = "", payload = null } = { ...action };

    switch (type) {
        case HomeV2Actions.SET_TALENT_INFORMATION: {
            return {
                ...state,
                talentInformationForHomePage: { ...state.talentInformationForHomePage, ...payload },
                loading: false,
            };
        }

        case HomeV2Actions.SET_ROLE_TYPE_ID: {
            return {
                ...state,
                talentInformationForHomePage: { ...state.talentInformationForHomePage, roleTypeId: payload },
                loading: false,
            };
        }

        case HomeV2Actions.SET_COUNTRY_ID_AND_CITY: {
            return {
                ...state,
                talentInformationForHomePage: { ...state.talentInformationForHomePage, countryId: payload.countryId, city: payload.city },
                loading: false,
            };
        }

        case HomeV2Actions.SET_COUNTRIES: {
            return {
                ...state,
                countries: payload || [],
                loading: false,
            };
        }

        case HomeV2Actions.SET_JOB_ROLE_TYPES: {
            return {
                ...state,
                jobRoleTypes: payload || [],
                loading: false,
            };
        }

        case HomeV2Actions.LOADING: {
            return {
                ...state,
                loading: payload,
            };
        }

        default:
            return state;
    }
}


export default HomeV2Reducer;